import { AxiosError } from 'axios';
import { CommandResult, FormApiService, QueryApiService } from 'src/common/api-service';
import { RichText } from '../common';

export class EnterpriseFeatureApiService extends QueryApiService<EnterpriseFeatureApiService> {
  constructor() {
    super('enterpriseFeature');
  }
}

export class EnterpriseFeatureFromApiService extends FormApiService {
  constructor() {
    super('enterpriseFeature');
  }

  public async vote(id: string) {
    try {
      const result = await super.put<{}, CommandResult>({}, `${id}/vote`);
      return result;
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }
}

export class EnterpriseProposalFromApiService extends FormApiService {
  constructor() {
    super('enterpriseProposal');
  }

  public async proposal(body: { proposal: RichText }) {
    try {
      const result = await super.post<{ proposal: RichText }, CommandResult>(body);
      return result;
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }
}
